import IndexNavbar from 'components/Navbars/IndexNavbar'
import React from 'react'

const ARDrawTerms = () => {
    React.useEffect(() => {
        document.body.classList.add("index-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        return function cleanup() {
            document.body.classList.remove("index-page", "sidebar-collapse");
        };
    }, []);

    return (
        <>
            <div className="wrapper">
                <div className="main">
                    <div className="terms-container">
                        <header className="terms-header">
                            <h1>Terms of Use for AR Anime & AR Draw</h1>
                            <p className="last-updated">Effective Date: 01 October 2024</p>
                        </header>

                        <section className="terms-intro">
                            <p>
                                Welcome to AR Anime & AR Draw! These Terms of Use (&quot;Terms&quot;) are a legally binding agreement between you (&quot;User,&quot; &quot;you,&quot; or &quot;your&quot;) and CRYPTO FINANCIAL SOLUTION CO., LTD (&quot;Company,&quot; &quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) governing your access to and use of the AR Anime & AR Draw mobile application (&quot;App&quot;) available on the Apple App Store.
                            </p>
                            <p className="highlight-box">
                                <strong>Important:</strong> By downloading, accessing, or using AR Anime & AR Draw, you agree to be bound by these Terms. If you do not agree with these Terms, please do not use the App.
                            </p>
                        </section>

                        <section>
                            <h2>1. App Overview</h2>
                            <p>
                                AR Anime & AR Draw provides augmented reality drawing tools that allow users to create and trace artwork using their device camera.
                            </p>
                        </section>

                        <section>
                            <h2>2. Eligibility</h2>
                            <p>
                                You must be at least 13 years old (or the equivalent minimum age in your jurisdiction) to use this App. If you are between 13 and 18 years old, you may only use the App with the involvement of a parent or guardian who agrees to these Terms.
                            </p>
                        </section>

                        <section>
                            <h2>3. License to Use the App</h2>
                            <p>
                                We grant you a limited, non-exclusive, non-transferable, and revocable license to download, install, and use the App for personal, non-commercial purposes on devices that you own or control. The App may only be used in accordance with these Terms and any applicable laws and regulations.
                            </p>
                        </section>

                        <section>
                            <h2>4. User Conduct</h2>
                            <p>You agree not to:</p>
                            <ul className="legal-list">
                                <li>Use the App for any illegal, unauthorized, or prohibited purposes.</li>
                                <li>Interfere with the proper functioning of the App or the network it operates on.</li>
                                <li>Use the App to upload, distribute, or otherwise make available any content that is unlawful, harmful, or violates the rights of others.</li>
                            </ul>
                        </section>

                        <section>
                            <h2>5. Privacy</h2>
                            <p>
                                Your privacy is important to us. By using the App, you agree to our collection, use, and sharing of your information as described in our Privacy Policy.
                            </p>
                        </section>

                        <section>
                            <h2>6. Intellectual Property</h2>
                            <p>
                                All intellectual property rights in the App, including but not limited to software, design, text, and graphics, are owned by CRYPTO FINANCIAL SOLUTION CO., LTD or its licensors. You agree not to copy, reproduce, or create derivative works based on the App.
                            </p>
                        </section>

                        <section>
                            <h2>7. Disclaimer of Warranties</h2>
                            <p>
                                The App is provided &quot;as is&quot; and &quot;as available&quot; without warranties of any kind. We make no representations or warranties regarding the accuracy, completeness, reliability, or availability of the App. You use the App at your own risk.
                            </p>
                        </section>

                        <section>
                            <h2>8. Limitation of Liability</h2>
                            <p>
                                To the fullest extent permitted by law, CRYPTO FINANCIAL SOLUTION CO., LTD shall not be liable for any direct, indirect, incidental, special, or consequential damages arising out of or related to your use of the App.
                            </p>
                        </section>

                        <section>
                            <h2>9. Termination</h2>
                            <p>
                                We reserve the right to terminate or suspend your access to the App at any time, with or without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
                            </p>
                        </section>

                        <section>
                            <h2>10. Changes to the Terms</h2>
                            <p>
                                We may update these Terms from time to time to reflect changes in our practices or the App&apos;s functionality. We will notify you of any material changes by posting the updated Terms on the App or through other means. Your continued use of the App after such changes constitutes your acceptance of the updated Terms.
                            </p>
                        </section>

                        <section>
                            <h2>11. Governing Law</h2>
                            <p>
                                These Terms are governed by the laws of Vietnam, without regard to its conflict of laws principles. Any disputes arising from or relating to these Terms will be subject to the exclusive jurisdiction of the courts located in Vietnam.
                            </p>
                        </section>

                        <section>
                            <h2>12. Contact Information</h2>
                            <p>
                                If you have any questions about these Terms, please contact us at{' '}
                                <a href="mailto:admin@cryptofinancialsolution.com" className="email-link">admin@cryptofinancialsolution.com</a>.
                            </p>
                        </section>

                        <footer className="terms-footer">
                            <p>By using AR Anime & AR Draw, you acknowledge that you have read, understood, and agree to these Terms of Use.</p>
                        </footer>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ARDrawTerms;
